import { combineReducers, configureStore } from '@reduxjs/toolkit';
import {
  persistStore,
  persistReducer,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER
} from 'redux-persist';
import storage from 'redux-persist/lib/storage';

import authSlice from './slices/authSlice';
import commonSlice from './slices/commonSlice';
import callingSlice from './slices/callingSlice';
import dialSlice from './slices/dialSlice';
import dashboardSlice from './slices/dashboardSlice';
import realtimeReportSlice from './slices/tenantSlices/realtimeReportSlice';
import dailyReportSlice from './slices/tenantSlices/dailyReportSlice';
import callHistorySlice from './slices/callHistorySlice';
import agentPerformanceSlice from './slices/tenantSlices/agentPerformanceSlice';
import configurationSlice from './slices/tenantSlices/configurationSlice';
import settingSlice from './slices/tenantSlices/settingSlice';
import incomingSlice from './slices/tenantSlices/incomingSlice';
import tenantDashboardSlice from './slices/tenantSlices/tenantDashboardSlice';
import companySlice from './slices/adminSlices/companySlice';
import productSlice from './slices/tenantSlices/productSlice';
import modulePermissionSlice from './slices/adminSlices/modulePermissionSlice';
import companyRoleSlice from './slices/adminSlices/companyRoleSlice';
import supervisorSlice from './slices/tenantSlices/supervisorSlice';
import adminDashboardSlice from './slices/adminSlices/adminDashboardSlice';
import auditorSlice from './slices/tenantSlices/auditorSlice';
import chatSlice from './slices/tenantSlices/chatSlice';
import helpDeskSlice from './slices/tenantSlices/helpDeskSlice';
import metaHelpDeskSlice from './slices/tenantSlices/metaHelpDeskSlice';
import auditorDashboardSlice from './slices/tenantSlices/auditorDashboardSlice';
import timezoneSlice from './slices/adminSlices/timezoneSlice';
import brandingDetailSlice from './slices/adminSlices/brandingDetailSlice';
import brandingSlice from './slices/adminSlices/brandingSlice';
import aiRealtimeReportSlice from './slices/tenantSlices/aiRealtimeReportSlice';

// REDUCERS
const rootReducer = combineReducers({
  auth: authSlice,
  common: commonSlice,
  calling: callingSlice,
  dial: dialSlice,
  dashboard: dashboardSlice,

  tenantDashboard: tenantDashboardSlice,
  realtimeReport: realtimeReportSlice,
  dailyReport: dailyReportSlice,
  callHistory: callHistorySlice,
  agentPerformance: agentPerformanceSlice,
  configuration: configurationSlice,
  setting: settingSlice,
  incoming: incomingSlice,
  product: productSlice,
  branding: brandingSlice,
  brandingDetail: brandingDetailSlice,

  adminDashboard: adminDashboardSlice,
  company: companySlice,
  modulePermission: modulePermissionSlice,
  timezone: timezoneSlice,
  companyRole: companyRoleSlice,
  supervisor: supervisorSlice,
  auditor: auditorSlice,
  chat: chatSlice,
  helpDesk: helpDeskSlice,
  metaHelpDesk: metaHelpDeskSlice,

  auditorDashboard: auditorDashboardSlice,
  aiRealtimeReport: aiRealtimeReportSlice
});

const persistConfig = {
  key: 'root',
  storage
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

/* ============================== STORE ============================== */

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
        ignoredActionPaths: ['payload', 'meta.arg'],
        ignoredPaths: ['payload', 'meta.arg']
      }
    })
});

/* ============================== PERSIST-STORE ============================== */

export const persistor = persistStore(store);
